const underMaintenance = ()=>{
    return(
        <h4>Under Maintenance</h4>
    );
}

export default underMaintenance;